var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',_vm._b({staticClass:"el-menu-pro",attrs:{"default-active":_vm.activeIndex},on:{"select":_vm.handleSelect}},'el-menu',_vm.props,false),_vm._l((_vm.menuList),function(item,index){return _c('submenuComponent',{key:index,attrs:{"obj":item,"index":index+'',"fields":_vm.fields}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }